import React, {Component} from 'react';
import {observer} from 'mobx-react';
import MarkupToolButton from './MarkupToolButton';
import {ReactComponent as BackIcon} from "../../../assets/images/mobile-back.svg";
import {ReactComponent as IconTrash} from '../../../assets/images/trash-card.svg';
import {ReactComponent as IconHand} from '../../../assets/images/studio/markup/icon-hand.svg';

@observer
class MarkupLeftActions extends Component {

    render() {
        const {isSelectionMode, activateSelection, goBackMenu, clear, isSubMenu} = this.props;

        return (
            <div className='markup-left-actions'>
                <MarkupToolButton
                    icon={<IconHand/>}
                    iconViewBox="0 0 16 16"
                    toolTipText="markup.tooltip.move.tool"
                    onClick={activateSelection}
                    buttonClass='hand'
                    isActive={isSelectionMode}/>

                {isSubMenu &&
                    <MarkupToolButton
                        icon={<BackIcon/>}
                        iconViewBox="0 0 9 14"
                        onClick={goBackMenu}
                        buttonClass='back'/>
                }

                {!isSubMenu &&
                <MarkupToolButton
                    icon={<IconTrash/>}
                    iconViewBox="0 0 16 16"
                    toolTipText="markup.tooltip.delete.markup"
                    onClick={clear}
                    buttonClass='clear'/>
                }
            </div>
        )
    }
}


export default MarkupLeftActions;
